// src/components/FAQ.jsx
import React, { useState } from "react";
import "./FAQ.css";

const faqItems = [
  {
    question: "How do I book an appointment?",
    answer:
      "To book an appointment, browse through available services, select your preferred provider, choose a date and time, and confirm your booking. You'll receive a confirmation email once your appointment is booked.",
  },
  {
    question: "Can I cancel or reschedule my appointment?",
    answer:
      "Yes, you can cancel or reschedule your appointment from your dashboard at least 24 hours in advance.",
  },
  {
    question: "How do I reset my password?",
    answer:
      "Click 'Forgot Password' on the login page, enter your registered email, and follow the instructions to reset your password.",
  },
  {
    question: "What payment methods are accepted?",
    answer:
      "We accept major credit/debit cards, SnapConX Wallet, and EFT for select services.",
  },
  {
    question: "How will I be notified about my appointment?",
    answer:
      "You'll receive an email and optional SMS reminder 24 hours before your appointment.",
  },
  {
    question: "What if I'm running late for my appointment?",
    answer:
      "Please contact the provider as soon as possible. Late arrivals may result in a shorter service or cancellation.",
  },
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="faq-container">
      <h2>Frequently Asked Questions</h2>
      {faqItems.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "open" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggle(index)}>
            {item.question}
          </div>
          {activeIndex === index && (
            <div className="faq-answer">{item.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
}
